import gql from 'graphql-tag';

const F_SURVEY_INFO = `
    id
    org_id
    campaign_id
    author_id
    title
    description
    instructions
    is_public
    is_open
    start_date
    end_date
    created_at
    updated_at
`;

const M_CREATE_ADV_SURVEY = gql`
    mutation CreateSurvey($campaign_id: uuid, $title: String, $description: String, $instructions: String, $is_open: Boolean, $is_public: Boolean, $start_date: timestamptz, $end_date: timestamptz) {
        insert_surveys(objects: { campaign_id: $campaign_id, description: $description, instructions: $instructions, is_open: $is_open, is_public: $is_public, title: $title }) {
            returning {
                id
                org_id
                campaign_id
                author_id
                title
                description
                instructions
                is_public
                is_open
                start_date
                end_date
                created_at
                updated_at
            }
        }
    }
`;


const M_CREATE_BASIC_SURVEY = gql`
    mutation CreateSurvey($title: String!, $description: String, $instructions: String, $survey_type_id: Int!) {
        insert_surveys(objects: {title: $title, description: $description, instructions: $instructions, survey_type_id: $survey_type_id}) {
            returning {
                ${F_SURVEY_INFO}
            }
        }
    }
`;

const M_UPDATE_BASIC_SURVEY = gql`
    mutation UpdateSurvey($survey_id: uuid!, $title: String, $description: String, $instructions: String) {
        update_surveys(where: {id: {_eq: $survey_id}}, _set: { title: $title, description: $description, instructions: $instructions}) {
            returning {
               ${F_SURVEY_INFO}
            }
        }
    }
`;


const M_CREATE_SURVEY_SECTION_AS_CONTAINER = gql`
    mutation CreateSectionAsContainer($survey_id: uuid!) {
        insert_survey_sections(objects: { survey_id: $survey_id, is_container_only: true }) {
            returning {
                id
            }
        }
    }
`;

const M_CREATE_SURVEY_QUESTION = gql`
    mutation InsertQuestions($answer_is_required: Boolean, $question_index: Int, $question_is_required: Boolean, $question_subtitle: String, $question_title: String, $question_type: question_types_enum, $survey_section_id: uuid, $answer_groups: answer_groups_arr_rel_insert_input!) {
        insert_questions(objects: { answer_is_required: $answer_is_required, question_index: $question_index, question_is_required: $question_is_required, question_subtitle: $question_subtitle, question_title: $question_title, question_type: $question_type, survey_section_id: $survey_section_id, answer_groups: $answer_groups }) {
            returning {
                id
                answer_is_required
                created_at
                question_index
                question_is_required
                question_subtitle
                question_title
                question_type
                survey_section_id
                updated_at
                answer_groups {
                    id
                }
            }
        }
    }
`;

const M_UPDATE_SURVEY_QUESTION = gql`
    mutation UpdateQuestion($question_id: uuid, $question_index: Int, $question_title: String, $question_subtitle: String, $question_type: question_types_enum) {
        update_questions(
            where: { id: { _eq: $question_id } },
            _set: { question_index: $question_index, question_title: $question_title, question_subtitle: $question_subtitle, question_type: $question_type }
        ) {
            affected_rows
        }
    }
`;

const M_DELETE_SURVEY_QUESTION = gql`
    mutation DeleteQuestionAndAnswers($question_id: uuid, $answer_group_id: uuid) {
        delete_possible_answers(where: { answer_group_id: { _eq: $answer_group_id } }) {
            affected_rows
        }
        delete_answer_groups(where: { id: { _eq: $answer_group_id } }) {
            affected_rows
        }
        delete_questions(where: { id: { _eq: $question_id } }) {
            affected_rows
        }
    }
`;


/*  possible_answers_insert_input =
    [{
        answer_group_id: uuid
        answer_index: Int
        answer_text: String
    }]
*/
const M_CREATE_ANSWERS = gql`
    mutation CreateAnswers($new_answers: [possible_answers_insert_input!]!) {
        insert_possible_answers(objects: $new_answers) {
            returning {
                answer_group_id
                answer_index
                answer_text
                created_at
                id
                updated_at
            }
        }
    }  
`;

const M_UPDATE_ANSWER = gql`
    mutation UpdateAnswers($answer_group_id: uuid, $answer_id: uuid, $answer_index: Int, $answer_text: String) {
        update_possible_answers(
            where: { _and: { answer_group_id: { _eq: $answer_group_id }, id: { _eq: $answer_id } } },
            _set: { answer_index: $answer_index, answer_text: $answer_text }
        ) {
            affected_rows
        }
    }
`;
  

const M_DELETE_ANSWERS = gql `
    mutation DeleteAnswers($removeAnswerIds: [uuid!]) {
        delete_possible_answers(where: { id: { _in: $removeAnswerIds } }) {
            affected_rows
        }
    }
`;

const M_INSERT_USER_ANSWERS = gql`
    mutation InsertSurveyUserAnswers($user_answers: [user_answers_insert_input!]!) {
        insert_user_answers(objects: $user_answers) {
            affected_rows
        }
    }
`;

const M_INSERT_ANON_USER_ANSWERS = gql`
    mutation InsertSurveyAnonUserAnswers($user_answers: [anon_user_answers_insert_input!]!) {
        insert_anon_user_answers(objects: $user_answers) {
            affected_rows
        }
    }
`;

export {
    // surveys
    M_CREATE_BASIC_SURVEY,
    M_CREATE_ADV_SURVEY,
    M_UPDATE_BASIC_SURVEY,

    // sections
    M_CREATE_SURVEY_SECTION_AS_CONTAINER,

    // questions
    M_CREATE_SURVEY_QUESTION,
    M_UPDATE_SURVEY_QUESTION,
    M_DELETE_SURVEY_QUESTION,

    // answers
    M_CREATE_ANSWERS,
    M_UPDATE_ANSWER,
    M_DELETE_ANSWERS,

    // user answers
    M_INSERT_USER_ANSWERS,
    M_INSERT_ANON_USER_ANSWERS
}
  